/**
 * 广告配置文件
 * 用于控制是否加载广告
 */

const adConfig = {
  // 控制是否加载广告SDK和执行广告填充
  enableAdLoading: true,
  
  // 广告SDK脚本URL
  adSdkUrl: 'https://sdk.broadsolutionsgroup.com/perfect_sdk_info_mixed.js',
  
  // 广告ID配置
  adIds: {
    homeAd1: 'seattle-ad-10001',    // 首页广告1 (原 homeInline)
    homeAd2: 'seattle-ad-10002',    // 首页广告2 (原 homeSidebar)
    homeAd3: 'seattle-ad-10003',    // 首页广告3
    homeAd4: 'seattle-ad-10004',    // 首页广告4
    homeAd5: 'seattle-ad-10005',    // 首页广告5
    defaultAd: 'seattle-ad-10001'      // 其他页面广告统一ID (可以保留或更新)
  }
};

export default adConfig; 